import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home/index";
import Navbar from "./components/NavAndFooter/Navbar";
import Footer from "./components/NavAndFooter/Footer";
//import About from "./components/About/index";
import Gallery from "./components/Gallery/index";
import Contact from "./components/Contact/index";
import Appointment from "./components/Appointment/index";

function App() {
  return (
    <div style={{ overflowX: "hidden", width: "100%" }}>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/appointment" element={<Appointment />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
